import { ShieldCheck, Clock, XCircle } from "lucide-react";
import type { BookingStatus } from "../services/dataService"; // adjust path

interface Props {
  status: BookingStatus;
}

export function StatusBadge({ status }: Props) {
  switch (status) {
    case "confirmed":
      return (
        <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-[10px] font-black uppercase tracking-widest inline-flex items-center gap-1">
          <ShieldCheck size={12} /> Bevestigd
        </span>
      );

    case "pending_payment":
      return (
        <span className="px-3 py-1 bg-amber-100 text-amber-800 rounded-full text-[10px] font-black uppercase tracking-widest inline-flex items-center gap-1">
          <Clock size={12} /> Wachten op betaling
        </span>
      );

    case "pending":
      return (
        <span className="px-3 py-1 bg-amber-100 text-amber-800 rounded-full text-[10px] font-black uppercase tracking-widest inline-flex items-center gap-1">
          <Clock size={12} /> In behandeling
        </span>
      );

    case "payment_failed":
      return (
        <span className="px-3 py-1 bg-red-100 text-red-700 rounded-full text-[10px] font-black uppercase tracking-widest inline-flex items-center gap-1">
          <XCircle size={12} /> Betaling mislukt
        </span>
      );

    case "payment_expired":
      return (
        <span className="px-3 py-1 bg-red-100 text-red-700 rounded-full text-[10px] font-black uppercase tracking-widest inline-flex items-center gap-1">
          <XCircle size={12} /> Betaallink verlopen
        </span>
      );

    case "cancelled":
      return (
        <span className="px-3 py-1 bg-stone-200 text-stone-700 rounded-full text-[10px] font-black uppercase tracking-widest inline-flex items-center gap-1">
          <XCircle size={12} /> Geannuleerd
        </span>
      );
  }
}
